import { emitMixpanelUserEvent, TaxonomyTrackingEvents } from '@revelio/core';

import { kibanaLogger } from '../../../../shared/logging/kibana-logger';
import type { TaxonomyFilterRemoval } from './taxonomyFilterRemoval';

type TaxonomyFilterRemovalOrigin =
  | { source: 'url' }
  | { source: 'saved_set'; savedSetId: string };

export type TaxonomyFilterRemovalEvent = TaxonomyFilterRemoval & {
  taxonomy: 'role' | 'skill' | 'activity' | 'geography';
};

// URL validation re-runs until the URL sync rewrites the param; dedupe Kibana logs per removal and path.
const loggedUrlRemovals = new Set<string>();

export const trackTaxonomyFiltersRemoved = (
  removal: TaxonomyFilterRemovalEvent,
  origin: TaxonomyFilterRemovalOrigin
) => {
  const savedSetId =
    origin.source === 'saved_set' ? origin.savedSetId : undefined;
  const path = window.location.pathname;

  emitMixpanelUserEvent(TaxonomyTrackingEvents.TAXONOMY_FILTERS_REMOVED, {
    source: origin.source,
    taxonomy: removal.taxonomy,
    reason: removal.reason,
    saved_version: removal.savedVersion,
    current_version: removal.currentVersion,
    saved_set_id: savedSetId,
    path,
  });

  if (origin.source === 'url') {
    const key = JSON.stringify([removal, path]);
    if (loggedUrlRemovals.has(key)) return;
    loggedUrlRemovals.add(key);
  }

  const details = [
    `source=${origin.source}`,
    `reason=${removal.reason}`,
    `saved=${removal.savedVersion ?? 'none'}`,
    `current=${removal.currentVersion ?? 'none'}`,
    ...(savedSetId ? [`saved_set_id=${savedSetId}`] : []),
  ].join(' ');
  kibanaLogger?.warn(
    `${removal.taxonomy} filters removed due to taxonomy changes: ${details}`,
    { context: 'taxonomy-filters-removed' }
  );
};
